<style scoped>
</style>
<template>
  <div>
    <transition :name="transitionName">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>

    <!-- <transition :name="transitionName">
      <router-view v-if="!$route.meta.keep_alive"></router-view>
    </transition> -->
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  data() {
    return {
      transitionName: ""
    }
  }, //监听路由的路径，可以通过不同的路径去选择不同的切换效果
  created() {

   // this.getAllPowers()

   
  },
  watch: {
    '$route'(to, from) {
      let isBack = this.$router.isBack //  监听路由变化时的状态为前进还是后退

      this.$router.isBack = false
    }
  },
  methods: {
    toTree(obj) {
      let name_arr = obj.name.split('_');
      let icon_arr = obj.icon.split('_');
      let ptr = this.store.state.sidebar_arr;

      for (let i = 0; i < name_arr.length; i++) {
        let node = { name: name_arr[i], icon: icon_arr[i], id: i + obj.id ,show:obj.show}
        //如果是最后的层级，把path加到最后的层级那里
        if (i == name_arr.length - 1) {
          node.path = obj.path
        }
        let Index = ptr.findIndex(item => { return item.name === name_arr[i] })
        if (Index === -1) {
          node.children = []
          ptr.push(node)
        } else {
          //ptr[Index].children = ptr[Index].children
        }
        //如果找到上级，那么下次就找上级的children，如果找不到上级，就从新push的node找
        let index = Index > -1 ? Index : ptr.length - 1
        ptr = ptr[index].children
      }
    },

    getAllPowers() {

      var params = {

      };

      this.req.get(url_api_admin_adminRole_getAllPowers, this.qs.stringify(params)).then((result) => {

        var all_powers = JSON.parse(result.all_powers)
        var role_powers = JSON.parse(result.role_powers)

        //筛选一次role_powers,如果权限列表改变了，但是没有进行update某个角色权限，这时候是有差距的，放前端筛选是不想后端过多这段代码

        A: for (var i = 0; i < all_powers.length; i++) {

          for (var j = 0; j < role_powers.length; j++) {

            //对比3个参数，如果所有都对上，就break掉，如果没有能对的上的，就删除
            if (all_powers[i]["name"] == role_powers[j]["name"] && all_powers[i]["path"] == role_powers[j]["path"] && all_powers[i]["api"] == role_powers[j]["api"]) {

              continue A
            }

          }
          all_powers.splice(i, 1)
          i = i - 1
        }

        //把固定要显示的页面，根据all_powers的构造加上，这样后面可以生成路由
        all_powers.unshift({
          api: "",
          icon: "s-home",
          name: "欢迎使用_placeholder",//这里留一个固定的【方法】给去删除
          path: "/admin/other/welcome",
		  show:"true",
        })

        // all_powers.push({
        //   api: "",
        //   icon: "s-help",
        //   name: "系统模块_坐标转换_placeholder",//这里留一个固定的【方法】给去删除
        //   path: "/admin/system/coordinate",
        // })

        //分隔name_arr,删除最后一个，因为最后一个为方法名称
        for (let i = 0; i < all_powers.length; i++) {
          let name_arr = all_powers[i]["name"].split("_")
          name_arr.splice(name_arr.length - 1, 1)
          all_powers[i]["name"] = name_arr.join("_")
          all_powers[i]["id"] = i + ''

        }


        //添加到路由
        for (let i = 0; i < all_powers.length; i++) {
          let power = all_powers[i];
          let path_arr = power["path"].split("/")
          let name_arr = power["name"].split("_")

          path_arr.splice(0, 2, "pages")
          //这里用let常量才能传递给下面require异步，如果用var总是会被最后一个覆盖
          let component = path_arr.join("/")
          let name = name_arr[name_arr.length - 1]
          let component_name = path_arr[path_arr.length - 1]


          this.$router.options.routes[0].children.push(
            {
              path: power["path"],
              component: (resolve) => {
                require([`@@/${component}.vue`], resolve)
              },
              meta: {
                keep_alive: false,
                require_login: true,
                name: name,
                component_name: component_name,

              }
            }
          )

        }

        // this.$router.options.routes[0].children.push(
        //   {
        //     path: "/admin/system/form_builder",
        //     component: (resolve) => {
        //       require([`@@/pages/system/form_builder.vue`], resolve)
        //     },
        //     meta: {
        //       keep_alive: false,
        //       require_login: false,
        //       name: "form_builder",
        //       component_name: "form_builder",

        //     }
        //   }
        // )
        this.$router.addRoutes(this.$router.options.routes)




        //构造el-menu需要的tree格式
        let filter_arr = []
        for (let i = 0; i < all_powers.length; i++) {
          let power = this.utils.copy(all_powers[i])
          delete power.api
          if (!filter_arr.find((f) => {
            return f.name == power.name
          })) {
            filter_arr.push(power)
          }
        }
        filter_arr.map(this.toTree)




      }).catch((error) => {
        this.utils.errorMessage(error)
      });
    }
  }

}
</script>